import React, { Component } from "react";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavbarToggler,
  Collapse,
  NavItem,
} from "reactstrap";
import { NavLink, withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/shared/Shared";
import Badge from "@material-ui/core/Badge";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import SideCart from "../Cart/SideCart";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import Chip from "@material-ui/core/Chip";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SignDialog from "../SignIn/SignDialog";
import GlobalSearch from "../../Common/GlobalSearch";
import {
  getCartItems,
  getCartItemsLocal,
  toggleSignUp,
} from "../../../store/actions/user/User";
import { Button, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import PlacesWithStandaloneSearchBox from "../Home/map";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import firebaseApp from "../../../constants/firebase";
import CurrencySelector from "../../Flight/CurrencySelector.js";
import axios from "axios";
import IconMenu from "@material-ui/icons/Menu";
import Hidden from "@material-ui/core/Hidden";
import { Search } from "@mui/icons-material";
// import logo from "../../../assets/img/image.jpeg";
// import logo from "../../../assets/img/Logo2.png";
import logo from "../../../assets/img/logo.jpeg";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authUser: localStorage.getItem("userLoginType"),
      isNavOpen: false,
      opencart: false,
      signOpen: false,
      globalSearchText: "",
      openLocationPopup: false,
      pathName: "",
    };
    this.toggleNav = this.toggleNav.bind(this);
    this.logout = this.logout.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleSignClose = this.handleSignClose.bind(this);
    this.handleSignOpen = this.handleSignOpen.bind(this);
  }

  componentDidMount() {
    if (this.props.auth) {
      this.props.getCartItems();
      let messaging = null;
      if (firebaseApp.messaging.isSupported()) {
        messaging = firebaseApp.messaging();
      }
      if (messaging) {
        messaging
          .requestPermission()
          .then(async function () {
            const token = await messaging.getToken();
            localStorage.setItem("firebase_token", token);
            axios
              .post(`/api_v_1/user/save-firebase-token`, {
                firebaseToken: token,
              })
              .then(function (response) {})
              .catch((e) => {
                console.log(e);
              });
          })
          .catch(function (err) {
            console.log("Unable to get permission to notify.", err);
          });
      }
    } else {
      this.props.getCartItemsLocal();
    }
    this.locationRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.state.pathName !== this.props.history?.location?.pathname) {
      this.setState({
        isNavOpen: false,
        pathName: this.props.history?.location?.pathname,
      });
    }
    if (this.props.auth && prevProps.auth !== this.props.auth) {
      this.setState({
        isNavOpen: false,
      });
      this.props.getCartItems();
      let messaging = null;
      if (firebaseApp.messaging.isSupported()) {
        messaging = firebaseApp.messaging();
      }
      if (messaging) {
        messaging
          .requestPermission()
          .then(async function () {
            const token = await messaging.getToken();
            localStorage.setItem("firebase_token", token);
            axios
              .post(`/api_v_1/user/save-firebase-token`, {
                firebaseToken: token,
              })
              .then(function (response) {})
              .catch((e) => {
                console.log(e);
              });
          })
          .catch(function (err) {
            console.log("Unable to get permission to notify.", err);
          });
      }
    }
  }

  logout() {
    let firebaseToken = localStorage.getItem("firebase_token");
    axios
      .post(`/api_v_1/user/logout`, {
        firebaseToken: firebaseToken,
      })
      .then(function (response) {})
      .catch((e) => {
        console.log(e);
      });
    this.props.logoutUser();
    this.props.history.push("/");
    window.location.reload();
  }

  handleLocationSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("city", this.state.location);
    this.setState({
      location: localStorage.getItem("city"),
    });
  };

  toggleNav() {
    this.setState({
      isNavOpen: !this.state.isNavOpen,
    });
  }
  handleSubmit(e) {
    e.preventDefault();
  }

  handleOpen() {
    this.setState({ opencart: true });
    // this.props.history.push('/');
  }

  handleClose() {
    this.setState({ opencart: false });
  }
  handleSignOpen() {
    this.props.toggleSignUp(true);
    this.setState({ signOpen: true });
  }
  handleSignClose() {
    this.props.toggleSignUp(false);

    this.setState({ signOpen: false });
  }

  getNavLink(authUser) {
    switch (authUser) {
      case "admin":
        return "/admin";
      case "vendor":
        return "/vendor";
      case "driver":
        return "/driver";
      default:
        return "/my-profile";
    }
  }

  handleSearchSubmit() {
    const { globalSearchText } = this.state;
    if (globalSearchText && globalSearchText.length >= 3) {
      this.props.history.push("/search/" + globalSearchText);
    }
  }

  // handleLocationOpen() {
  //   this.setState({
  //     openLocationPopup: true
  //   })
  // }

  // handleLocationOpenClose() {
  //   this.setState({
  //     openLocationPopup: false
  //   })
  //   this.props.history.push("/")
  // }

  render() {
    const { auth } = this.props;
    const path = window.location.pathname;
    return (
      <div>
        <SignDialog
          open={this.props.signupOpen}
          onClose={this.handleSignClose}
        ></SignDialog>
        <SideCart open={this.state.opencart} onClose={this.handleClose} />
        {/* <Dialog
          open={this.state.openLocationPopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Please select your Location"}
            {localStorage.getItem("street") &&
              <IconButton aria-label="close" onClick={this.handleLocationOpenClose.bind(this)}>
                <CloseIcon />
              </IconButton>
            }
          </DialogTitle>
          <DialogContent>
          </DialogContent>
          <DialogActions>
            <PlacesWithStandaloneSearchBox
              handleClose={this.handleLocationOpenClose.bind(this)}
              location={this.locationRef}
            ></PlacesWithStandaloneSearchBox>
          </DialogActions>
        </Dialog> */}
        <Navbar
          expand="lg"
          className="bg-white"
          style={{
            display: "block",
            boxShadow: "0px 4px 8px 2px #d1d1d11f",
          }}
        >
          <div
            className="container col-lg-12 col-md-12 bg-white"
            style={{
              width: `${path.includes("/flights-book/v") ? "80%" : "70%"}`,
              backgroundColor: "FFFFFF",
            }}
          >
            <NavbarBrand className="col col-lg-3 col-md-5 mr-0 p-0 text-left">
              <NavLink to="/" style={{ textDecoration: "none" }}>
                {/* <img src="/img/l.png" alt="" height={"70"} style={{marginLeft:'-70px'}}/>hh */}
                <img
                  src={logo}
                  width={"160px"}
                  height={"auto"}
                  alt="Travel Pick"
                />
                {/* <Typography
                  variant="h6"
                  style={{
                    fontWeight: 900,
                    color: "#129880",
                    textDecoration: "none",
                    textAlign: "left",
                  }}
                >
                <img src={logo} width={"200"} height={"100"} alt="Travel Pick" />
                </Typography> */}
              </NavLink>
            </NavbarBrand>
            <NavbarToggler onClick={this.toggleNav}>
              <IconMenu style={{ fontSize: "25px", color: "#000000" }} />
            </NavbarToggler>
            <Hidden xsUp implementation="css">
              <div className="col col-lg-5 col-md-5 mr-0 pl-0"></div>
            </Hidden>
            <Collapse
              isOpen={this.state.isNavOpen}
              navbar
              className="col-md-5 col-sm-12 mobile-menu"
              style={{ flexDirection: "row-reverse" }}
            >
              <Nav
                navbar
                style={{
                  gap: "1rem",
                  alignItems: "center",
                  flexDirection: "row-reverse",
                }}
              >
                <NavItem>
                  <CurrencySelector
                    readOnly={this.state.authUser == "vendor"}
                    currencyChangeHandler={(value) => {}}
                  />
                </NavItem>

                {auth ? (
                  <>
                    <NavItem className="mr-3 ">
                      <NavLink
                        className="nav-link"
                        to={this.getNavLink(this.state.authUser)}
                      >
                        <Chip
                          variant="outlined"
                          style={{
                            background: "var(--themegreen)",
                            border: "none",
                            color: "var(--white)",
                            fontWeight: "bold",
                          }}
                          clickable={true}
                          icon={
                            <AccountCircleIcon
                              style={{ color: "var(--white)" }}
                            />
                          }
                          label="My Account"
                          color="#01A05A"
                        />
                      </NavLink>
                    </NavItem>
                    <NavItem className="mr-3 ">
                      <NavLink className="nav-link" to="/">
                        <Chip
                          variant="outlined"
                          style={{
                            fontWeight: 700,
                            color: "var(--darker)",
                            border: "1px solid #fff",
                          }}
                          onClick={this.logout}
                          clickable={true}
                          icon={
                            <ExitToAppIcon style={{ color: "var(--darker)" }} />
                          }
                          label="Logout"
                        />
                      </NavLink>
                    </NavItem>
                  </>
                ) : (
                  <NavItem className="nav-link">
                    {/* <Chip
                      variant="outlined"
                      style={{
                        background: 'var(--green)',
                        border: 'none',
                        color: 'var(--white)',
                        fontWeight: 'bold'
                      }}
                      onClick={this.handleSignOpen}
                      clickable={true}
                      icon={<AccountCircleIcon style={{ color: 'var(--white)' }}  />}
                      label="Sign in / Log in"
                      color="#fff"
                    /> */}
                    <Typography
                      onClick={this.handleSignOpen}
                      style={{ cursor: "pointer" }}
                    >
                      SIGN IN
                    </Typography>
                  </NavItem>
                )}
                <Search />
              </Nav>
            </Collapse>
          </div>
        </Navbar>
      </div>
    );
  }
}
const mapStateWithProps = (state) => ({
  auth: state.user.auth,
  cart: state.user.cart,
  signupOpen: state.user.signupOpen,
});
const mapDispatchToProps = (dispatch) => ({
  logoutUser: () => dispatch(logoutUser()),
  toggleSignUp: (isOpen) => dispatch(toggleSignUp(isOpen)),
  getCartItems: () => dispatch(getCartItems()),
  getCartItemsLocal: () => dispatch(getCartItemsLocal()),
});

export default connect(
  mapStateWithProps,
  mapDispatchToProps
)(withRouter(Header));
